import React from 'react';
import PropTypes from 'prop-types';
import { EffortTypeCard } from './EffortTypeCard';
import styles from './EffortTypesSection.module.css';

export const EffortTypesSection = ({ 
  effortTypes, 
  selectedEffortType, 
  onEffortTypeSelect 
}) => {
  return (
    <div className={styles.section}>
      <div className={styles.effortGrid}>
        {effortTypes.map((effort) => (
          <EffortTypeCard
            key={effort.id}
            type={effort.type}
            level={effort.level}
            effort={effort.effort}
            color={effort.color}
            borderColor={effort.borderColor}
            isSelected={selectedEffortType === effort.id}
            onClick={() => onEffortTypeSelect(effort.id)}
          />
        ))}
      </div>
    </div>
  );
};

EffortTypesSection.propTypes = {
  effortTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      level: PropTypes.string.isRequired,
      effort: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      borderColor: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedEffortType: PropTypes.string,
  onEffortTypeSelect: PropTypes.func.isRequired
};